// extracted by mini-css-extract-plugin
module.exports = {"LikeSection__button":"cn_a pz_rf"};